import { graphql } from '@/gql';

export const UPDATE_BEWERTUNG = graphql(`
  mutation mitarbeiter_updateRotationsplanBewertung(
    $input: mitarbeiter_updateRotationsplanBewertungInput!
  ) {
    mitarbeiter_updateRotationsplanBewertung(input: $input) {
      success {
        bewertung {
          id
          sterne
          beurteilung
        }
      }
      error {
        message
      }
    }
  }
`);
